import axios from 'axios';
import { LoginData } from '../../shared/organism/Auth/Login/type/login-data';
import { FetcherFn } from '../type/fetcher-fn';

export async function requestCurrentUser(
  locale: string,
  fetcher: FetcherFn<{ accessToken: string }>,
): Promise<string | null> {
  try {
    const { data, status } = await fetcher(`/${locale}/public/get-auth-data`);

    if (status !== 200) {
      return null;
    }

    return data.accessToken;
  } catch (e) {
    return null;
  }
}

export async function login(data: LoginData, locale: string) {
  try {
    await axios.post(`/${locale}/login`, {
      ...data,
    });

    const location = `/${locale}/cabinet/settings`;
    document.location.href = location;

    return {};
  } catch (e) {
    return { error: 'error' };
  }
}
